import { render, staticRenderFns } from "./tabLogisticsBillImport.vue?vue&type=template&id=85adcb5e&scoped=true&"
import script from "./tabLogisticsBillImport.vue?vue&type=script&lang=js&"
export * from "./tabLogisticsBillImport.vue?vue&type=script&lang=js&"
import style0 from "./tabLogisticsBillImport.vue?vue&type=style&index=0&id=85adcb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85adcb5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85adcb5e')) {
      api.createRecord('85adcb5e', component.options)
    } else {
      api.reload('85adcb5e', component.options)
    }
    module.hot.accept("./tabLogisticsBillImport.vue?vue&type=template&id=85adcb5e&scoped=true&", function () {
      api.rerender('85adcb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/AIReconciliation/components/tabLogisticsBillImport.vue"
export default component.exports